// Shared chat logic for the global / clan / DM channels, used by BOTH backends
// (Cloudflare D1 functions + the node:sqlite dev server) and the client, so the
// channel-id scheme and message validation are defined in exactly one place.

export const MAX_MSG_LEN = 200; // max characters in a single message body
export const RATE_MS = 2000; // minimum ms between posts per author (any channel)
export const KEEP_PER_CHANNEL = 200; // trim-on-insert: messages retained per channel

export function globalChannel() {
  return "global";
}

export function clanChannel(id) {
  return `clan:${id}`;
}

// Deterministic, order-independent DM channel id: a sorted, lowercased pair —
// mirrors the friendRoomId trick so both participants always land on the same
// channel string regardless of who opens the thread.
export function dmChannel(a, b) {
  return `dm:${[String(a).toLowerCase(), String(b).toLowerCase()].sort().join("__")}`;
}

// Parse a `dm:a__b` channel back into its two participant names (lowercased), or
// null if the string isn't a well-formed DM channel. Used to authorize access.
export function dmParticipants(channel) {
  if (typeof channel !== "string" || !channel.startsWith("dm:")) return null;
  const parts = channel.slice(3).split("__");
  if (parts.length !== 2 || !parts[0] || !parts[1] || parts[0] === parts[1]) return null;
  return parts;
}

export function isGlobalChannel(channel) {
  return channel === "global";
}

// Extract the clan id from a `clan:<id>` channel, or null. Returns a number.
export function clanChannelId(channel) {
  if (typeof channel !== "string" || !channel.startsWith("clan:")) return null;
  const id = Number(channel.slice(5));
  return Number.isInteger(id) && id > 0 ? id : null;
}

// Shape-validate + clean a message body: collapse runs of whitespace, trim, and
// reject empty / over-length. Moderation (containsBlockedWord) is checked by the
// caller so it can return a distinct "blocked" error. Returns the cleaned body
// or null.
export function validateBody(raw) {
  if (typeof raw !== "string") return null;
  const s = raw.replace(/\s+/g, " ").trim();
  if (s.length === 0 || s.length > MAX_MSG_LEN) return null;
  return s;
}
